// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d3Uv","type":"styles_type__27rPd","choices":"styles_choices__1fH_t"};